/**
 * The exact text a page SMS goes out as, and what it costs in segments — mirrored from
 * Services/Audience/SmsText.cs so the builder's counter and preview match what sends.
 */
export const SMS_MAX_BODY = 320;
export const SMS_STOP_LINE = 'Reply STOP to opt out.';

// GSM 03.38 basic set (the ESC and CR/LF control characters are handled by code point below).
const GSM7 = '@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM7_EXT = '^{}\\[~]|€';
const GSM7_CONTROL = new Set([10, 13, 27]);

export function composeSms(pageName, body) {
  const name = (pageName || '').trim();
  const text = (body || '').trim();
  let s = '';
  if (name) s += `${name}: `;
  s += text;
  if (text) s += ' ';
  s += SMS_STOP_LINE;
  return s;
}

export function isGsm7(s) {
  for (const ch of s) {
    if (GSM7_CONTROL.has(ch.charCodeAt(0))) continue;
    if (!GSM7.includes(ch) && !GSM7_EXT.includes(ch)) return false;
  }
  return true;
}

/** Segments a carrier bills for the composed text: 160 / 153 GSM-7, 70 / 67 UCS-2. */
export function smsSegments(composed) {
  if (!composed) return 0;
  if (isGsm7(composed)) {
    let units = 0;
    for (const ch of composed) units += GSM7_EXT.includes(ch) ? 2 : 1;
    return units <= 160 ? 1 : Math.ceil(units / 153);
  }
  return composed.length <= 70 ? 1 : Math.ceil(composed.length / 67);
}
